/**
 * This class protects against:
 * <ol>
 *   <li>\n and \r in the string, which can be used to make a single string look like two log entries (see https://cwe.mitre.org/data/definitions/117.html)</li>
 * </ol>
 */
export class SafeLogger {
    public static info(msg?: any, ...optionalParams: any) {
      this.consoleLog('info', msg, optionalParams);
    }
    public static warn(msg?: any, ...optionalParams: any) {
      this.consoleLog('warn', msg, optionalParams);
    }
    public static error(msg?: any, ...optionalParams: any) {
      this.consoleLog('error', msg, optionalParams);
    }
    public static log(msg?: any, ...optionalParams: any) {
      this.consoleLog('log', msg, optionalParams);
    }
    public static debug(msg?: any, ...optionalParams: any) {
      this.consoleLog('debug', msg, optionalParams);
    }
    public static trace(msg?: any, ...optionalParams: any) {
      this.consoleLog('trace', msg, optionalParams);
    }
  
    private static consoleLog(level: string, msg?: any, ...optionalParams: any[]): void {
      const logFunction: any = console.log || function() {};
  
      const m = this.sanitize(msg);
      const args = optionalParams.map(parm => this.sanitize(parm))
  
      if (args[0].length > 0)
        logFunction('=== '+m, ...args[0]);
      else
        logFunction('=== '+m);
    }
  
    static sanitize(unsafe: any) {
      if ((typeof unsafe) !== 'string')
        return unsafe;
  
      return unsafe
        .replace(/\n/g, "&#10;")
        .replace(/\r/g, "&#13;")
    }
  }